// extracted by mini-css-extract-plugin
export var darkBlue = "#003e52";
export var darkGreen = "#3b693d";
export var green = "#3dae2b";
export var lightGreen = "#93d500";
export var newsGreen = "#ecf5d7";
export var orange = "#f90";
export var yellow = "#fbc900";
export var paleBlue = "#64a1bb";
export var blue = "#67b9e8";
export var blueishGrey = "#adc6d6";
export var coolGrey = "#e1e2e0";
export var white = "#fff";
export var almostWhite = "#f2eded";
export var lightGrey = "#d3d3d3";
export var lightishGrey = "#aba9a9";
export var grey = "#828382";
export var darkishGrey = "#666";
export var darkGrey = "#4b4d4b";
export var almostBlack = "#333";
export var error = "#ff3a3a";
export var warning = "#ffd162";
export var success = "#1ebc7b";
export var section = "PageLayout-module--section--vRpFf";
export var container = "PageLayout-module--container--1d8Vb";
export var containerTop = "PageLayout-module--containerTop--2nPvE";
export var circlesBackgroundContainer = "PageLayout-module--circlesBackgroundContainer--bAwNo";
export var circlesBackground = "PageLayout-module--circlesBackground--EwHVu";
export var containerTopLeft = "PageLayout-module--containerTopLeft--1Lokk";
export var containerTopLeftFullWidth = "PageLayout-module--containerTopLeftFullWidth--IvGwT";
export var containerTopRight = "PageLayout-module--containerTopRight--YywCi";
export var mockContainerTopRight = "PageLayout-module--mockContainerTopRight--lpUAx";
export var withPageContentBox = "PageLayout-module--withPageContentBox--3Kcku";
export var filtersButton = "PageLayout-module--filtersButton--xYXdT";
export var containerBottom = "PageLayout-module--containerBottom--31uFv";
export var containerBottomLeftWindow = "PageLayout-module--containerBottomLeftWindow--2zoEI";
export var withSideCircles = "PageLayout-module--withSideCircles--2QqoM";
export var containerBottomRight = "PageLayout-module--containerBottomRight--2LlEK";
export var containerBottomFullWidth = "PageLayout-module--containerBottomFullWidth--2q8nq";
export var title = "PageLayout-module--title--FgHc2";
export var containerBottomLeft = "PageLayout-module--containerBottomLeft--oSMEc";
export var menuOpen = "PageLayout-module--menuOpen--JZ-7x";